/**
 * Engineering-proxy’s voor constructiekwaliteit — géén kopie van ISSO/NTA-tabellen (auteursrecht / certificering).
 * Schaalfactoren passen de bestaande bouwjaar-U-proxy aan; gebruiker kiest bewust een scenario.
 */
export const CONSTRUCTIE_TABEL_IDS = [
    'standaard_bouwjaar',
    'issoproxy_streng',
    'issoproxy_versoepeld',
    'renovatie_doel_armer',
    'nieuwbouw_proxy',
];
export const CONSTRUCTIE_TABEL_LABELS = {
    standaard_bouwjaar: 'Standaard — alleen bouwjaar + isolatieprofiel (bestaande engine)',
    issoproxy_streng: 'Proxy “streng” — lagere U (strakkere schil); geen officiële ISSO-waarde, wel typisch voor vergelijkingen',
    issoproxy_versoepeld: 'Proxy “versoepeld” — hogere U (slappe schil) voor gevoeligheidsanalyse',
    renovatie_doel_armer: 'Proxy renovatiedoel — merkbaar lagere U t.o.v. bouwjaar (doelbeeld)',
    nieuwbouw_proxy: 'Proxy nieuwbouw — lage U zonder BENG-dossier',
};
/** Vermenigvuldigt de opake U-proxy (niet glas). */
export function constructieTabelUSchaal(modus) {
    switch (modus) {
        case 'standaard_bouwjaar':
            return 1;
        case 'issoproxy_streng':
            return 0.88;
        case 'issoproxy_versoepeld':
            return 1.12;
        case 'renovatie_doel_armer':
            return 0.72;
        case 'nieuwbouw_proxy':
            return 0.62;
        default:
            return 1;
    }
}
export const CONSTRUCTIE_TABEL_LEGAL_NOTE = 'Modi zijn interne schaalfactoren op de ComfortTool U-proxy. Ze vervangen geen gelabelde ISSO/NTA-constructietabellen en zijn niet voor officiële energielabelaangifte.';
